<template>
  <div class="time_nav_placeholder">
    <div class="time_nav_wrapper">
      <div class=' swiper-container'>
        <ul class="time_nav swiper-wrapper">
          <li class="time_nav_cell swiper-slide" v-if="index==0" :class='index==redIndex?"now":""' v-for="(grapBuyingTime,index) in grapBuyingTimes" @click="showGoodsList(index,grapBuyingTime,'grapping1')">
            <p>热抢好货</p>
            <p>已开抢</p>
            <span class="trangle"></span>
          </li>
          <li class="time_nav_cell swiper-slide" v-if="index==1" :class='index==redIndex?"now":""' v-for="(grapBuyingTime,index) in grapBuyingTimes" @click="showGoodsList(index,grapBuyingTime,'grapping2')">
            <p>{{grapBuyingTime}}:00</p>
            <p>疯抢中</p>
            <span class="trangle"></span>
          </li>
          <li class="time_nav_cell swiper-slide" v-if="index>1" :class='index==redIndex?"now":""' v-for="(grapBuyingTime,index) in grapBuyingTimes" @click="showGoodsList(index,grapBuyingTime,'grap')">
            <p>{{grapBuyingTime}}:00</p>
            <p>即将开抢</p>
            <span class="trangle"></span>
          </li>

        </ul>
      </div>
    </div>
  </div>
</template>
<script type = "text/ecamscript-6">
  import Vue from 'vue'
  import { Indicator } from 'mint-ui' //提示搜索优惠券
  import SwiperVue from 'swiper'
  import 'swiper/dist/css/swiper.min.css'
  export default {
    name:"grapBuyingNav",
    data () {
      return{
        grapBuyingTimes:[8],
        redIndex:1,
        begin:""
      }
    },
    created() {
      var t = new Date()//获取当前时间
      var hours = t.getHours();//获取当前小时
      let hoursArray = [];
      this.begin = "";
      hours == 8?this.begin = 9:this.begin = hours//设定时间数组第二个参数
      for(let i = this.begin;i<24;i++){
        hoursArray.push(i)
      }
      this.grapBuyingTimes = [...this.grapBuyingTimes,...hoursArray];//获取导航时间
      console.log(this.grapBuyingTimes)
    },
    methods:{
      //点击显示时间导航
      showGoodsList(index,startime,grap) {
        this.redIndex = index;
        this.$emit("lisetenToChildEvent",startime,grap,this.begins)
      }
    }
    }

</script>
<style lang="stylus">
  .time_nav_placeholder
    height:100px
    width:100%
    .time_nav_wrapper
      height:100px
      width:100%
      background:#000
      position:fixed
      left:0px
      top:0px
      z-index:99
      .swiper-container
        overflow:visible
        .time_nav
          color:#fff
          display:flex
          flex-wrap:nowrap
          align-items:center
          text-align:center
          height:118px
          padding-bottom:18px
          box-sizing:border-box
          .time_nav_cell
            padding-top:10px
            height:100px
            position:relative
            box-sizing:border-box
            &.now
              background:#e63c00
              .trangle
                width:0px
                height:0px
                border:9px solid transparent
                border-top:9px solid #e63c00
                position:absolute
                bottom:-18px
                left:50%
                transform:translateX(-50%)
                display:block
</style>



// WEBPACK FOOTER //
// src/components/goodsNav/grapBuyingNav.vue